import { render, staticRenderFns } from "./Bwns.vue?vue&type=template&id=45f221e9&"
import script from "./Bwns.vue?vue&type=script&lang=js&"
export * from "./Bwns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports